import { IDefineCommand } from 'core-ts-types';
import { ICommand } from 'core-ts-types';

angular.module('lib').service('declineTOUCommand', (
  defineCommandORM: IDefineCommand,
  logoutCommand: ICommand,
  $state: ng.ui.IStateService) => {
  return defineCommandORM('declineTOUCommand', (deferred) => {
    logoutCommand($state);
    deferred.resolve();
  });
});



// WEBPACK FOOTER //
// ./app/lib/tos/commands/decline_tou_command.ts